<template>
  <div class="container z-depth-1 mt-5 p-lg-5">
    <!-- Section -->
    <section class="provider-body">
      <h2 class="font-weight-bold text-center section-title pb-2">
        Comment ça marche pour les fournisseurs&nbsp;?
      </h2>
      <hr class="w-header my-4" />
      <p class="lead text-center section-lead pt-2 mb-5">
        En quelques étapes, votre dépôt est connecté au réseau Livratos&nbsp;:
        vous créez vos <strong>livraisons</strong>, nous gérons les
        <strong>livreurs</strong> et vous êtes facturé en fin de période.
      </p>

      <div class="row d-flex justify-content-center px-3">
        <!-- Étape 1 : Inscription -->
        <div class="col-md-6 col-xl-4 slide-left">
          <div class="step-label step-1">
            <h3 class="font-weight-normal service-title">
              1. Inscription en ligne
            </h3>
            <p class="small service-tag">Création de votre compte dépôt</p>
          </div>
        </div>

        <div class="col-md-6 slide-right">
          <div class="step-panel step-1">
            <p class="service-text mb-5 pb-2">
              Vous créez votre compte <strong>fournisseur</strong> en quelques
              minutes&nbsp;: Email et mot de passe pour accéder à votre compte
              livratos, coordonnées de l’enseigne, adresses de dépôts, et
              documents à téléversés. Une fois la demande envoyée, vos
              informations arrivent directement à notre équipe pour validation.
            </p>
          </div>
        </div>

        <!-- Étape 2 : Activation du compte -->
        <div class="col-md-6 col-xl-4 slide-left">
          <div class="step-label step-2">
            <h3 class="font-weight-normal service-title">
              2. Activation par Livratos
            </h3>
            <p class="small service-tag">Contrôle & parametrage</p>
          </div>
        </div>

        <div class="col-md-6 slide-right">
          <div class="step-panel step-2">
            <p class="service-text mb-5 pb-2">
              Une fois votre compte créé et votre profil complété (coordonnées,
              raison sociale, documents obligatoires…), notre équipe vérifie
              votre dossier puis vous contacte avant toute activation. C’est à
              ce moment-là que nous voyons ensemble la meilleure façon de lancer
              le service&nbsp;: activation immédiate, organisation d’une démo de
              la plateforme, ou accompagnement plus poussé pour former vos
              équipes et vous aider à prendre en main l’outil. Une fois ces
              derniers points validés avec vous, votre compte
              <strong>fournisseur</strong> est activé.
            </p>
          </div>
        </div>

        <!-- Étape 3 : Création des livraisons -->
        <div class="col-md-6 col-xl-4 slide-left">
          <div class="step-label step-3">
            <h3 class="font-weight-normal service-title">
              3. Créez vos livraisons
            </h3>
            <p class="small service-tag">Express & programmées</p>
          </div>
        </div>

        <div class="col-md-6 slide-right">
          <div class="step-panel step-3">
            <p class="service-text mb-5 pb-2">
              Depuis votre interface Livratos, vous déclenchez vos
              <strong>livraisons</strong>&nbsp;: point de départ (dépôt),
              <strong>chantier</strong> de destination, créneau horaire, type de
              véhicule et détail du chargement. La plateforme assigne un
              <strong>livreur indépendant</strong> adapté et vous suivez chaque
              course jusqu’à la remise sur chantier.
            </p>
          </div>
        </div>

        <!-- Étape 4 : Facturation -->
        <div class="col-md-6 col-xl-4 slide-left">
          <div class="step-label step-4">
            <h3 class="font-weight-normal service-title">
              4. Facturation en fin de période
            </h3>
            <p class="small service-tag">Tout regroupé, tout tracé</p>
          </div>
        </div>

        <div class="col-md-6 slide-right">
          <div class="step-panel step-4">
            <p class="service-text mb-5 pb-2">
              Les <strong>livraisons</strong> réalisées sont regroupées sur une
              période définie (8&nbsp;jours ou fin de mois selon votre
              organisation). Vous recevez des factures détaillées au format PDF
              avec le récapitulatif des courses, des
              <strong>chantiers livrés</strong> et des montants associés, pour
              une comptabilité claire et sans paiements au coup par coup.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- Section -->
  </div>
</template>

<script>
export default {
  name: "ProviderBody",
};
</script>

<style lang="scss" scoped>
.provider-body {
  .section-title {
    color: $color-text;
  }

  .section-lead {
    color: $color-text-grey;
    font-size: 1.05rem;
  }

  /* Bloc titre + tag */
  .step-label {
    padding: 1.4rem 1.6rem;
    border-radius: 10px;
    margin-bottom: 1rem;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  }

  /* panneaux texte */
  .step-panel {
    padding: 1.1rem 1.4rem;
    border-radius: 10px;
    margin-bottom: 1.5rem;
    background-color: $background;
    border-left: 3px solid transparent;
  }

  .service-title {
    margin: 0;
    font-size: 1.2rem;
  }

  .service-tag {
    margin: 0.4rem 0 0;
    font-size: 0.85rem;
    font-weight: 600;
  }

  .service-text {
    color: $color-text-grey;
    font-size: 0.98rem;
    line-height: 1.6;
    margin: 0;
  }

  /* Alternance vert / noir */

  /* Étape 1 & 3 : fond vert */
  .step-1.step-label,
  .step-3.step-label {
    background-color: $color-primary;
    .service-title {
      color: #000;
    }
    .service-tag {
      color: #000;
      opacity: 0.85;
    }
  }

  .step-1.step-panel,
  .step-3.step-panel {
    border-left-color: $color-primary;
  }

  /* Étape 2 & 4 : fond noir */
  .step-2.step-label,
  .step-4.step-label {
    background-color: #000;
    .service-title {
      color: $color-primary;
    }
    .service-tag {
      color: #ffffff;
      opacity: 0.85;
    }
  }

  .step-2.step-panel,
  .step-4.step-panel {
    border-left-color: #000;
  }

  @media (max-width: 767.98px) {
    .step-label {
      text-align: left;
    }
    .section-lead {
      font-size: 1rem;
    }
  }
}
</style>
